import { mediaUrl } from '../api';

const TYPE_ICONS = {
  image: 'fa-regular fa-image',
  video: 'fa-solid fa-film',
  audio: 'fa-solid fa-music',
};

/**
 * A file of the media pool as it can be seen: the picture, a player, or an
 * icon for the kind of file. In the grid (`controls` off) a video shows its
 * first frame and audio only its icon - nothing plays from a thumbnail.
 */
function MediaPreview({ media, controls = false }) {
  const src = mediaUrl(media.url);

  if (media.mediaType === 'image') {
    return <img src={src} alt={media.description || ''} loading="lazy" />;
  }

  if (media.mediaType === 'video') {
    return (
      <video
        src={controls ? src : `${src}#t=0.1`}
        controls={controls}
        preload="metadata"
        muted={!controls}
      />
    );
  }

  if (media.mediaType === 'audio' && controls) {
    return <audio src={src} controls preload="metadata" />;
  }

  return (
    <span className="media-preview-icon">
      <i className={TYPE_ICONS[media.mediaType] || 'fa-regular fa-file'} />
      {media.extension && <small>.{media.extension}</small>}
    </span>
  );
}

export default MediaPreview;
